module.exports = __webpack_public_path__ + "assets/images/thin-caret.eeecf8c7ac5473516b961ee84ecb7ecb.svg";